import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, NgZone, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service, ChatMessage } from "src/libs/portal/ggeea/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  height: 100%;
  --violet-700: #7c3aed;
  --violet-500: #a855f7;
  --pink-500: #ec4899;
  --focus-ring: #2563eb;
  --focus-ring-soft: rgba(37, 99, 235, 0.18);
}

.page-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

.chat-header {
  min-height: 68px;
  box-shadow: 0 16px 28px -26px rgba(91, 33, 182, 0.34), 0 10px 18px -20px rgba(15, 23, 42, 0.16);
}

.chat-header__section {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
}

.chat-header__section--brand {
  justify-content: flex-start;
}

.chat-header__section--title {
  align-items: center;
  justify-content: center;
}

.chat-header__section--actions {
  justify-content: flex-end;
}

.chat-header__brand {
  max-width: 100%;
}

.chat-header__logo {
  height: 32px;
  width: auto;
}

.chat-header__menu-item {
  min-width: 100%;
}

.chat-header__menu-label {
  white-space: nowrap;
}

.chat-hero__inner {
  max-width: 420px;
}

.chat-hero {
  width: 100%;
}

.chat-hero__title {
  font-size: 21px;
  line-height: 1.5;
  letter-spacing: -0.03em;
}

.chat-hero__body {
  font-size: 13px;
  line-height: 1.8;
}

.chat-content,
.chat-input-wrap {
  max-width: 760px;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

header {
  animation: headerDrop 620ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.app-title {
  position: relative;
  text-shadow: 0 10px 28px rgba(124, 58, 237, 0.14);
}

.fade-in {
  animation: fadeRise 520ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.faq-deck {
  margin-top: 10px;
}

.faq-deck__stage {
  position: relative;
}

.faq-deck__viewport {
  overflow: hidden;
  margin: -4px -2px -8px;
  padding: 4px 2px 8px;
}

.faq-deck__track {
  display: flex;
  gap: 14px;
}

.faq-deck__slide {
  flex: 0 0 100%;
  min-width: 0;
}

.faq-deck__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
  transform-origin: center top;
  will-change: transform, opacity;
}

.faq-deck__grid.is-animating.is-next {
  animation: faqSlideInNext 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.faq-deck__grid.is-animating.is-prev {
  animation: faqSlideInPrev 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.faq-deck__grid.is-single {
  grid-template-columns: minmax(0, 1fr);
  max-width: 460px;
  margin: 0 auto;
}

.faq-card {
  min-height: 100%;
  padding: 22px 22px 18px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 255, 255, 0.86) 100%);
  box-shadow: 0 22px 40px -30px rgba(91, 33, 182, 0.28), 0 14px 22px -24px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  text-align: left;
}

.faq-card__title {
  font-size: 19px;
  line-height: 1.35;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #18181b;
}

.faq-card__description {
  margin-top: 6px;
  font-size: 12.5px;
  line-height: 1.65;
  color: #71717a;
}

.faq-card__list {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.faq-card__item {
  position: relative;
  width: 100%;
  min-width: 0;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid rgba(212, 212, 216, 0.9);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.99) 0%, rgba(250, 250, 252, 0.96) 100%);
  color: #18181b;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 700;
  text-align: left;
  word-break: keep-all;
  overflow-wrap: anywhere;
  box-shadow: 0 14px 24px -22px rgba(15, 23, 42, 0.24), 0 10px 18px -20px rgba(124, 58, 237, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.92);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease, background 180ms ease;
}

.faq-card__item::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, transparent 56%);
}

.faq-card__item:hover {
  transform: translateY(-2px);
  border-color: rgba(167, 139, 250, 0.95);
  box-shadow: 0 16px 28px -20px rgba(124, 58, 237, 0.3), 0 14px 24px -22px rgba(15, 23, 42, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.94);
}

.faq-deck__nav {
  position: absolute;
  top: 50%;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(228, 228, 231, 0.95);
  background: rgba(255, 255, 255, 0.96);
  color: #27272a;
  box-shadow: 0 18px 28px -22px rgba(15, 23, 42, 0.4);
  transform: translateY(-50%);
  transition: transform 180ms ease, box-shadow 180ms ease, color 180ms ease;
}

.faq-deck__nav:hover {
  color: #7c3aed;
  transform: translateY(-50%) scale(1.02);
  box-shadow: 0 18px 26px -20px rgba(124, 58, 237, 0.32);
}

.faq-deck__nav.is-prev {
  left: -18px;
}

.faq-deck__nav.is-next {
  right: -18px;
}

.faq-deck__dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
}

.faq-deck__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(212, 212, 216, 0.9);
  transition: width 180ms ease, background-color 180ms ease;
}

.faq-deck__dot.is-active {
  width: 26px;
  background: #7c3aed;
}

@media (max-width: 767px) {
  .faq-deck {
    margin-top: 6px;
  }
  .faq-deck__viewport {
    margin: -2px -20px 0 0;
    padding: 2px 0 2px;
    overflow: visible;
  }
  .faq-deck__viewport.is-mobile {
    padding-right: 0;
  }
  .faq-deck__track {
    overflow-x: auto;
    overflow-y: visible;
    padding: 2px 34px 8px 0;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 0;
    -webkit-overflow-scrolling: touch;
  }
  .faq-deck__slide {
    flex-basis: calc(100% - 54px);
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }
  .faq-deck__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
    max-width: 336px;
    margin: 0 auto;
  }
  .faq-card {
    padding: 15px 14px 12px;
    border-radius: 20px;
  }
  .faq-card__title {
    font-size: 16px;
    line-height: 1.3;
  }
  .faq-card__description {
    margin-top: 5px;
    font-size: 11.5px;
    line-height: 1.5;
  }
  .faq-card__list {
    gap: 7px;
    margin-top: 12px;
  }
  .faq-card__item {
    padding: 11px 13px;
    font-size: 12px;
    line-height: 1.38;
    border-radius: 14px;
  }
  .faq-deck__nav {
    display: none;
  }
  .faq-deck__dots {
    gap: 10px;
    margin-top: 2px;
  }
  .faq-deck__dots.is-mobile {
    min-height: 18px;
  }
  .faq-deck__dot {
    width: 14px;
    height: 14px;
    background: rgba(212, 212, 216, 0.92);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.8);
  }
  .faq-deck__dot.is-active {
    width: 38px;
    background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  }
}
.faq-panel {
  position: relative;
  margin-top: 2px;
  padding: 20px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.76) 100%);
  box-shadow: 0 26px 44px -32px rgba(91, 33, 182, 0.32), 0 16px 28px -28px rgba(236, 72, 153, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.92);
  overflow: hidden;
}

.faq-panel::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at top right, rgba(216, 180, 254, 0.22), transparent 34%), linear-gradient(135deg, rgba(255, 255, 255, 0.56), transparent 52%, rgba(244, 114, 182, 0.08));
}

.faq-panel__head,
.faq-panel__list {
  position: relative;
  z-index: 1;
}

.faq-panel__eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(139, 92, 246, 0.1);
  color: #7c3aed;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.faq-panel__title {
  margin-top: 12px;
  font-size: 19px;
  line-height: 1.45;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #18181b;
}

.faq-panel__description {
  margin-top: 8px;
  max-width: 560px;
  font-size: 12.5px;
  line-height: 1.72;
  color: #71717a;
}

.faq-panel__list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-top: 18px;
  max-height: min(46vh, 420px);
  overflow: auto;
  padding-right: 4px;
}

.faq-panel__item {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 14px 15px;
  border-radius: 20px;
  border: 1px solid rgba(228, 228, 231, 0.95);
  background: rgba(255, 255, 255, 0.88);
  text-align: left;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background-color 180ms ease;
}

.faq-panel__item:hover {
  transform: translateY(-1px);
  border-color: rgba(167, 139, 250, 0.92);
  background: rgba(250, 245, 255, 0.96);
  box-shadow: 0 14px 22px -20px rgba(124, 58, 237, 0.36);
}

.faq-panel__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.14) 0%, rgba(236, 72, 153, 0.14) 100%);
  color: #7c3aed;
  font-size: 12px;
  font-weight: 800;
}

.faq-panel__copy {
  min-width: 0;
}

.faq-panel__question {
  font-size: 13px;
  line-height: 1.58;
  font-weight: 700;
  color: #27272a;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.faq-panel__action {
  margin-top: 6px;
  font-size: 11.5px;
  font-weight: 700;
  color: #8b5cf6;
}

@media (min-width: 720px) {
  .faq-panel {
    padding: 22px;
  }
  .faq-panel__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.message-stack {
  padding-top: 6px;
}

.msg-enter {
  animation: bubbleIn 380ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.assistant-row {
  max-width: min(90%, 640px);
}

.assistant-row {
  align-items: flex-start;
  min-width: 0;
}

.chat-bubble-user,
.assistant-bubble {
  position: relative;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.chat-bubble-user {
  overflow: hidden;
}

.chat-bubble-user {
  max-width: min(78%, 560px);
  padding: 10px 16px;
  border-radius: 20px 20px 8px 20px;
  font-size: 13.5px;
  line-height: 1.72;
  color: #fff;
}

.chat-bubble-user:hover {
  transform: translateY(-1px);
}

.chat-bubble-user::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.18) 0%, transparent 52%, rgba(255, 255, 255, 0.08) 100%);
}

.assistant-avatar {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  margin-top: 4px;
  position: relative;
  overflow: visible;
  border-radius: 9999px;
  border: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
  animation: avatarFloat 4.2s ease-in-out infinite;
}

.assistant-avatar::before {
  content: "";
  position: absolute;
  inset: 5px;
  border-radius: inherit;
  background: radial-gradient(circle at 35% 30%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.08) 42%, transparent 72%);
  filter: blur(4px);
  opacity: 0.75;
  pointer-events: none;
}

.assistant-avatar::after {
  content: "";
  position: absolute;
  inset: auto 8px -3px 8px;
  height: 10px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.16) 0%, rgba(124, 58, 237, 0.08) 48%, transparent 72%);
  filter: blur(5px);
  opacity: 0.55;
  pointer-events: none;
}

.assistant-avatar.is-streaming {
  animation: avatarFloat 4.2s ease-in-out infinite;
}

.assistant-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 7px 10px rgba(91, 33, 182, 0.16)) drop-shadow(0 2px 4px rgba(15, 23, 42, 0.08));
  transform: translateY(-0.5px) scale(1.01);
}

.assistant-bubble {
  padding: 12px 16px;
  border-radius: 20px;
  font-size: 13.5px;
  min-width: 0;
  max-width: 100%;
  background: #ffffff;
  border-color: rgba(228, 228, 231, 0.92);
  white-space: normal;
  word-break: keep-all;
  overflow: visible;
  overflow-wrap: anywhere;
  line-break: auto;
  line-height: 1.8;
  box-shadow: 0 14px 26px -24px rgba(15, 23, 42, 0.24);
}

.assistant-bubble.is-streaming {
  border-color: rgba(196, 181, 253, 0.9);
  box-shadow: 0 16px 28px -24px rgba(124, 58, 237, 0.18);
}

.weather-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 55%, #ede9fe 100%);
  box-shadow: 0 10px 18px -12px rgba(59, 130, 246, 0.42), inset 0 1px 1px rgba(255, 255, 255, 0.9);
}

.weather-icon-fa {
  font-size: 22px;
  filter: drop-shadow(0 4px 8px rgba(30, 64, 175, 0.22));
}
.weather-icon-fa.fa-sun {
  color: #f59e0b;
  animation: spinSlow 20s linear infinite;
}
.weather-icon-fa.fa-cloud-sun {
  color: #fbbf24;
}
.weather-icon-fa.fa-cloud {
  color: #94a3b8;
}
.weather-icon-fa.fa-cloud-showers-heavy, .weather-icon-fa.fa-cloud-rain {
  color: #3b82f6;
}
.weather-icon-fa.fa-cloud-bolt {
  color: #8b5cf6;
}
.weather-icon-fa.fa-snowflake {
  color: #60a5fa;
  animation: spinSlow 14s linear infinite;
}
.weather-icon-fa.fa-smog {
  color: #9ca3af;
}

.weather-highlights {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 8px 0 10px;
}

.weather-highlight {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
  padding: 8px 9px;
  border-radius: 10px;
  background: rgba(248, 250, 252, 0.92);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.weather-highlight__icon {
  width: 18px;
  color: #2563eb;
  font-size: 14px;
  text-align: center;
}

.weather-highlight__copy {
  min-width: 0;
}

.weather-highlight__value {
  color: #18181b;
  font-size: 12.5px;
  line-height: 1.25;
  font-weight: 800;
  white-space: nowrap;
}

.weather-highlight__label {
  margin-top: 1px;
  color: #71717a;
  font-size: 10.5px;
  line-height: 1.2;
  font-weight: 700;
}

.weather-wind {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 8px;
  margin: 0 0 10px;
  padding: 7px 10px;
  border-radius: 999px;
  background: rgba(239, 246, 255, 0.9);
  color: #1d4ed8;
  font-size: 12px;
  line-height: 1.3;
  font-weight: 800;
}

.weather-wind__arrow {
  transform-origin: center;
  animation: windDrift 1200ms ease-in-out infinite;
}

.weather-wind__copy {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stream-loader {
  min-width: 208px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 3px 0;
}

.stream-loader-line {
  height: 10px;
  border-radius: 999px;
  background: #ececf1;
}

.stream-loader-line-1 {
  width: 116px;
}

.stream-loader-line-2 {
  width: 176px;
}

.stream-loader-foot {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stream-loader-label {
  font-size: 11.5px;
  color: #a1a1aa;
  letter-spacing: 0.02em;
}

.typing-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a1a1aa;
  opacity: 0.72;
  animation: none;
}

.typing-dot:nth-child(2) {
  opacity: 0.52;
}

.typing-dot:nth-child(3) {
  opacity: 0.34;
}

.md-content {
  position: relative;
  min-width: 0;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  line-break: auto;
  line-height: 1.82;
  letter-spacing: 0;
  color: #27272a;
}

:host ::ng-deep .md-content > *:first-child {
  margin-top: 0;
}

:host ::ng-deep .md-content > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .md-content p,
:host ::ng-deep .md-content li,
:host ::ng-deep .md-content blockquote,
:host ::ng-deep .md-content td,
:host ::ng-deep .md-content th {
  word-break: keep-all;
  overflow-wrap: anywhere;
  line-break: auto;
}

:host ::ng-deep .md-content p,
:host ::ng-deep .md-content ul,
:host ::ng-deep .md-content ol,
:host ::ng-deep .md-content blockquote,
:host ::ng-deep .md-content pre,
:host ::ng-deep .md-content table {
  margin: 0.68em 0;
}

:host ::ng-deep .md-content p + p,
:host ::ng-deep .md-content p + ul,
:host ::ng-deep .md-content p + ol,
:host ::ng-deep .md-content ul + p,
:host ::ng-deep .md-content ol + p,
:host ::ng-deep .md-content blockquote + p,
:host ::ng-deep .md-content p + blockquote {
  margin-top: 0.78em;
}

:host ::ng-deep .md-content h1,
:host ::ng-deep .md-content h2,
:host ::ng-deep .md-content h3,
:host ::ng-deep .md-content h4 {
  margin: 0.95em 0 0.42em;
  font-weight: 800;
  line-height: 1.45;
  letter-spacing: 0;
  color: #18181b;
}

:host ::ng-deep .md-content h1 {
  font-size: 1.18em;
}

:host ::ng-deep .md-content h2 {
  font-size: 1.11em;
}

:host ::ng-deep .md-content h3,
:host ::ng-deep .md-content h4 {
  font-size: 1.04em;
}

:host ::ng-deep .md-content ul,
:host ::ng-deep .md-content ol {
  padding-left: 1.45em;
  list-style-position: outside;
}

:host ::ng-deep .md-content ul {
  list-style-type: disc !important;
}

:host ::ng-deep .md-content ol {
  list-style-type: decimal !important;
}

:host ::ng-deep .md-content ul ul {
  list-style-type: circle !important;
}

:host ::ng-deep .md-content ul ul ul {
  list-style-type: square !important;
}

:host ::ng-deep .md-content ol ol {
  list-style-type: lower-alpha !important;
}

:host ::ng-deep .md-content ol ol ol {
  list-style-type: lower-roman !important;
}

:host ::ng-deep .md-content li + li {
  margin-top: 0.28em;
}

:host ::ng-deep .md-content li {
  display: list-item;
  padding-left: 0.12em;
}

:host ::ng-deep .md-content li::marker {
  color: #7c3aed;
  font-weight: 700;
}

:host ::ng-deep .md-content li > p {
  margin: 0;
}

:host ::ng-deep .md-content strong {
  font-weight: 800;
  color: #18181b;
}

:host ::ng-deep .md-content em {
  font-style: italic;
}

:host ::ng-deep .md-content code {
  padding: 0.12em 0.34em;
  border-radius: 6px;
  background: #f4f4f5;
  color: #6d28d9;
  font-size: 0.92em;
  font-weight: 700;
}

:host ::ng-deep .md-content pre {
  overflow-x: auto;
  padding: 0.85em 0.95em;
  border-radius: 12px;
  background: #27272a;
  color: #fafafa;
  line-height: 1.65;
}

:host ::ng-deep .md-content pre code {
  padding: 0;
  background: transparent;
  color: inherit;
  font-weight: 500;
}

:host ::ng-deep .md-content blockquote {
  padding-left: 0.9em;
  border-left: 3px solid rgba(167, 139, 250, 0.38);
  color: #52525b;
}

:host ::ng-deep .md-content table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
}

:host ::ng-deep .md-content th,
:host ::ng-deep .md-content td {
  padding: 0.42em 0.58em;
  border: 1px solid #e4e4e7;
  vertical-align: top;
}

:host ::ng-deep .md-content th {
  background: #f8fafc;
  color: #18181b;
  font-weight: 800;
}

:host ::ng-deep .md-content input[type=checkbox] {
  width: 1em;
  height: 1em;
  margin-right: 0.38em;
  vertical-align: -0.12em;
  accent-color: #7c3aed;
}

.md-content.is-streaming::after {
  content: "";
  display: inline-block;
  vertical-align: -0.12em;
  width: 9px;
  height: 1.08em;
  margin-left: 4px;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--violet-700) 0%, var(--pink-500) 100%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5), 0 0 14px rgba(168, 85, 247, 0.26);
  opacity: 0.82;
  animation: none;
}

.md-content a {
  color: #1e3a8a;
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 1.5px;
  text-decoration-color: #1d4ed8;
  text-underline-offset: 2px;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.md-content a:hover {
  color: #1d4ed8;
}

:host ::ng-deep .md-content :where(.citation-ref) {
  position: relative;
  gap: 4px;
  z-index: 2;
  padding: 0 2px;
  border-radius: 999px;
  text-decoration: none;
  text-underline-offset: 0;
  word-break: normal;
  overflow-wrap: normal;
  box-shadow: none !important;
  background: transparent !important;
  cursor: pointer;
}

:host ::ng-deep .md-content :where(.citation-ref.is-file) {
  color: #6d28d9 !important;
  box-shadow: none !important;
}

:host ::ng-deep .md-content :where(.citation-ref.is-file)::after {
  content: none;
}

:host ::ng-deep .md-content :where(.citation-ref.is-link) {
  background: transparent !important;
  color: #0f766e !important;
  box-shadow: none !important;
  text-decoration: none !important;
}

:host ::ng-deep .md-content :where(.citation-ref.is-link):hover {
  color: #115e59 !important;
}

:host ::ng-deep .md-content :where(.citation-ref.is-file):hover,
:host ::ng-deep .md-content :where(.citation-ref.is-file):focus-visible {
  color: #5b21b6 !important;
  text-decoration: underline !important;
}

:host ::ng-deep .md-content :where(.citation-ref.is-link):hover,
:host ::ng-deep .md-content :where(.citation-ref.is-link):focus-visible {
  text-decoration: underline !important;
}

:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  min-width: 180px;
  max-width: min(320px, 72vw);
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(24, 24, 27, 0.96);
  color: #fafafa;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
  white-space: pre-line;
  box-shadow: 0 12px 28px -18px rgba(24, 24, 27, 0.72);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 6;
}

:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: calc(100% + 3px);
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: rgba(24, 24, 27, 0.96);
  rotate: 45deg;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 5;
}

:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]:hover::before,
:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]:hover::after,
:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]:focus-visible::before,
:host ::ng-deep .md-content :where(.citation-ref)[data-tooltip]:focus-visible::after {
  opacity: 1;
  visibility: visible;
}

.chat-input-shell {
  position: relative;
  overflow: hidden;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: 0 24px 48px -32px rgba(91, 33, 182, 0.52), 0 16px 28px -26px rgba(236, 72, 153, 0.38) !important;
}

@media (max-width: 767px) {
  .chat-header {
    min-height: 44px;
    padding: 7px 12px;
  }
  .chat-header__logo {
    height: 20px;
  }
  .app-title {
    font-size: 12px;
    letter-spacing: 0.04em;
  }
  .chat-header__menu-button {
    width: 32px;
    height: 32px;
  }
  .chat-header__menu-panel {
    min-width: 152px;
  }
  .chat-header__menu-item {
    width: 100%;
    min-height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .chat-hero {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 8px;
    padding-bottom: 12px;
  }
  .chat-hero__inner {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  .chat-hero__title {
    font-size: 15px;
    line-height: 1.36;
  }
  .chat-hero__body {
    font-size: 11.5px;
    line-height: 1.6;
  }
  .chat-content,
  .chat-input-wrap {
    max-width: 100%;
  }
  .assistant-row {
    max-width: 100%;
  }
  .assistant-avatar {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    margin-top: 2px;
  }
  .assistant-bubble {
    padding: 11px 14px;
    border-radius: 18px;
    font-size: 13px;
    line-height: 1.75;
  }
  .chat-bubble-user {
    max-width: min(92%, 460px);
    padding: 10px 14px;
    font-size: 13px;
  }
  .stream-loader {
    min-width: 0;
    width: min(100%, 188px);
  }
  .chat-input-shell {
    border-radius: 24px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .chat-textarea {
    font-size: 13px;
  }
  .chat-send-button {
    width: 38px;
    height: 38px;
    border-radius: 16px;
  }
}
.chat-input-shell::before {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.84) 100%);
}

.chat-input-shell::after {
  content: "";
  position: absolute;
  left: 48px;
  right: 48px;
  bottom: -16px;
  height: 26px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.24) 0%, rgba(236, 72, 153, 0.16) 42%, transparent 74%);
  filter: blur(16px);
  opacity: 0;
  transition: opacity 180ms ease;
}

.chat-input-shell:focus-within::after {
  opacity: 1;
}

.chat-input-shell > * {
  position: relative;
  z-index: 1;
}

.chat-textarea,
.chat-textarea:focus,
.chat-textarea:focus-visible,
textarea,
textarea:focus,
textarea:focus-visible,
input[type=text],
input[type=text]:focus,
input[type=text]:focus-visible {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  -webkit-appearance: none;
  appearance: none;
}

.chat-textarea {
  border-radius: 0;
  caret-color: var(--violet-700);
}

.chat-textarea::placeholder {
  color: #a1a1aa;
  transition: color 160ms ease;
}

.chat-input-shell:focus-within .chat-textarea::placeholder {
  color: #c084fc;
}

:host :where(button:not(:disabled), a[href]):focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 3px;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.92), 0 0 0 7px var(--focus-ring-soft);
}

.chat-header__menu-item:focus-visible {
  outline-offset: -3px;
}

.faq-deck__dot:focus-visible {
  outline-offset: 4px;
}

.chat-input-shell:focus-within {
  outline: 3px solid var(--focus-ring) !important;
  outline-offset: 3px;
}

:host ::ng-deep .md-content a:focus-visible,
:host ::ng-deep .md-content :where(.citation-ref):focus-visible {
  border-radius: 6px;
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

@media (forced-colors: active) {
  :host :where(button:not(:disabled), a[href]):focus-visible,
  .chat-input-shell:focus-within,
  :host ::ng-deep .md-content a:focus-visible,
  :host ::ng-deep .md-content :where(.citation-ref):focus-visible {
    outline: 2px solid CanvasText !important;
    box-shadow: none !important;
  }
}
.chat-send-button {
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.chat-send-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0%, transparent 58%);
  opacity: 0;
  transition: opacity 180ms ease;
}

.chat-send-button:hover::before {
  opacity: 1;
}

.chat-send-button.is-loading {
  animation: sendBreath 1.35s ease-in-out infinite;
}

.cite-badge {
  display: inline-block;
  padding: 1px 6px;
  margin: 0 2px;
  border-radius: 8px;
  font-size: 11px;
  background: #dbeafe;
  color: #1e40af;
  cursor: pointer;
}

@keyframes headerDrop {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeRise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes faqSlideInNext {
  from {
    opacity: 0;
    transform: translate3d(24px, 0, 0) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes faqSlideInPrev {
  from {
    opacity: 0;
    transform: translate3d(-24px, 0, 0) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes bubbleIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes avatarFloat {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-4px) rotate(-2deg);
  }
}
@keyframes dotPulse {
  0%, 80%, 100% {
    opacity: 0.35;
    transform: scale(0.92);
  }
  40% {
    opacity: 0.9;
    transform: scale(1);
  }
}
@keyframes caretBlink {
  0%, 49% {
    opacity: 1;
  }
  50%, 100% {
    opacity: 0.16;
  }
}
@keyframes sendBreath {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 10px 18px -10px rgba(236, 72, 153, 0.35);
  }
  50% {
    transform: scale(1.04);
    box-shadow: 0 14px 22px -10px rgba(236, 72, 153, 0.48);
  }
}
@keyframes spinSlow {
  to {
    transform: rotate(360deg);
  }
}
@keyframes windDrift {
  0%, 100% {
    opacity: 0.62;
  }
  50% {
    opacity: 1;
  }
}`],
})
export class PageMainComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly sessionStorageKey = 'ggeea-session-id-v41';
    private readonly messagesStorageKey = 'ggeea-messages-v41';
    private readonly faqMobileBreakpoint = 767;
    private readonly faqItemsPerCard = 6;

    public messages: ChatMessage[] = [];
    public input: string = '';
    public sessionId: string | null = null;
    public loading: boolean = false;
    public version: string = '4.1';
    public menuOpen: boolean = false;

    public faqCategories: any[] = [];
    public faqItems: any[] = [];
    public faqCards: any[] = [];
    public faqPages: any[][] = [];
    public faqPageIndex: number = 0;
    public pageSize: number = 2;
    public faqAnimating: boolean = false;
    public faqMotion: 'next' | 'prev' = 'next';
    public faqIsMobile: boolean = false;

    // Smooth streaming
    private pendingChars: string[] = [];
    private pendingTarget: ChatMessage | null = null;
    private flushTimer: any = null;
    private faqAnimationTimer: any = null;
    private faqScrollFrame: number | null = null;
    private faqScrollSyncTimer: any = null;
    private scrollBottomTimer: any = null;
    private scrollBottomFrame: number | null = null;
    private scrollBottomTarget: number = 0;

    private converter: any;

    @ViewChild('scrollArea') scrollArea: ElementRef<HTMLDivElement> | null = null;
    @ViewChild('inputBox') inputBox: ElementRef<HTMLTextAreaElement> | null = null;
    @ViewChild('faqMobileTrack') faqMobileTrack: ElementRef<HTMLDivElement> | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( NgZone)  private zone: NgZone,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) {
        this.converter = new showdown.Converter({
            simpleLineBreaks: true,
            openLinksInNewWindow: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            strikethrough: true,
            tables: true,
            tasklists: true,
            emoji: true,
        });
    }
    public async ngOnInit() {
        await this.service.init();
        this.syncFaqViewport(true);
        const cached = sessionStorage.getItem(this.sessionStorageKey);
        if (cached) this.sessionId = cached;
        const cachedMsgs = sessionStorage.getItem(this.messagesStorageKey);
        if (cachedMsgs) {
            try { this.messages = JSON.parse(cachedMsgs); } catch (e) { }
        }
        sessionStorage.removeItem('ggeea-messages');
        sessionStorage.removeItem('ggeea-session-id');
        sessionStorage.removeItem('ggeea-messages-v31');
        sessionStorage.removeItem('ggeea-session-id-v31');
        sessionStorage.removeItem('ggeea-messages-v40');
        sessionStorage.removeItem('ggeea-session-id-v40');
        await this.loadFaq();
        void this.trackVisit();
        this.tick();
    }

    public ngAfterViewInit() {
        window.addEventListener('resize', this.onFaqViewportResize);
        this.queueFaqMobileScrollSync(false);
        setTimeout(() => this.focusInput(), 80);
    }

    public ngOnDestroy() {
        window.removeEventListener('resize', this.onFaqViewportResize);
        if (this.faqAnimationTimer) clearTimeout(this.faqAnimationTimer);
        if (this.faqScrollSyncTimer) clearTimeout(this.faqScrollSyncTimer);
        if (this.faqScrollFrame !== null) cancelAnimationFrame(this.faqScrollFrame);
        if (this.scrollBottomTimer) clearTimeout(this.scrollBottomTimer);
        if (this.scrollBottomFrame !== null) cancelAnimationFrame(this.scrollBottomFrame);
    }

    private tick() { try { this.cdr.detectChanges(); } catch (e) { } }

    public hasMessages(): boolean { return this.messages.length > 0; }

    public renderMd(message: ChatMessage | string): SafeHtml {
        const content = typeof message === 'string' ? message : String(message?.content || '');
        const citations = typeof message === 'string' ? [] : (Array.isArray(message?.citations) ? message.citations : []);
        if (!content) return '';
        try {
            const normalizedContent = this.normalizedCitationContent(content, citations);
            const normalized = this.linkifyPlainUrls(normalizedContent);
            let html = this.converter.makeHtml(normalized);
            // Ensure every <a> opens in a new tab and is safe (showdown's option adds target
            // but not rel; add rel="noopener noreferrer" and force target=_blank if missing).
            html = html.replace(/<a\b([^>]*)>/gi, (m, attrs) => {
                let a = attrs || '';
                if (!/\btarget\s*=/.test(a)) a += ' target="_blank"';
                if (!/\brel\s*=/.test(a)) a += ' rel="noopener noreferrer"';
                return `<a${a}>`;
            });
            html = this.linkifyCitationMarkers(html, citations);
            return this.sanitizer.bypassSecurityTrustHtml(html);
        } catch (e) {
            return content;
        }
    }

    public citationActionHref(citation: any, index: number): string {
        if (this.citationIsDownloadable(citation)) {
            return this.citationDownloadLink(citation, index);
        }
        return this.citationLink(citation) || this.citationDownloadLink(citation, index);
    }

    public citationActionTarget(citation: any): string | null {
        if (this.citationIsDownloadable(citation)) return null;
        return this.citationLink(citation) ? '_blank' : null;
    }

    public citationActionRel(citation: any): string | null {
        if (this.citationIsDownloadable(citation)) return null;
        return this.citationLink(citation) ? 'noopener noreferrer' : null;
    }

    public citationDownloadLink(citation: any, index: number): string {
        const params = new URLSearchParams();
        const documentId = String(citation?.document_id || '').trim();
        const sourceUrl = this.citationLink(citation);
        const title = this.citationTitle(citation, index);
        if (documentId) params.set('document_id', documentId);
        if (sourceUrl) params.set('source_url', sourceUrl);
        if (title) params.set('title', title);
        const query = params.toString();
        return query ? `/api/ggeea/chat/citation?${query}` : '/api/ggeea/chat/citation';
    }

    public citationLink(citation: any): string {
        const raw = String(citation?.source_url || '').trim();
        if (!raw) return '';
        if (/^https?:\/\//i.test(raw)) return raw;
        if (/^www\./i.test(raw)) return `https://${raw}`;
        return '';
    }

    public citationTitle(citation: any, index: number): string {
        const title = String(citation?.document_title || '').trim();
        if (title) return title;
        const link = this.citationLink(citation);
        if (link) {
            try {
                const parsed = new URL(link);
                return parsed.hostname.replace(/^www\./, '');
            } catch (e) {
                return link;
            }
        }
        return `출처 ${index + 1}`;
    }

    public citationMeta(citation: any): string {
        const link = this.citationLink(citation);
        if (link) return link.replace(/^https?:\/\//i, '');
        const excerpt = String(citation?.text || '').replace(/\s+/g, ' ').trim();
        if (!excerpt) return '참고 문서';
        return excerpt.length > 80 ? `${excerpt.slice(0, 80)}...` : excerpt;
    }

    public citationTooltip(citation: any, index: number): string {
        const actionText = this.citationIsDownloadable(citation)
            ? '클릭하면 파일을 다운로드합니다.'
            : '클릭하면 새 창에서 링크를 엽니다.';
        return `${this.citationTitle(citation, index)}\n${this.citationMeta(citation)}\n${actionText}`;
    }

    public citationBadgeLabel(citation: any): string {
        if (!this.citationIsDownloadable(citation)) return '';
        const ext = this.citationExtension(citation);
        if (ext === 'pdf') return 'PDF';
        if (ext) return ext.toUpperCase();
        return 'FILE';
    }

    public citationIsDownloadable(citation: any): boolean {
        const sourceType = String(citation?.source_type || '').trim().toLowerCase();
        const filePath = String(citation?.file_path || '').trim();
        const mime = String(citation?.mime || '').trim().toLowerCase();
        const ext = this.citationExtension(citation);
        if (filePath) return true;
        if (sourceType === 'file' || sourceType === 'pdf' || sourceType === 'upload') return true;
        if (mime && !mime.startsWith('text/html')) return true;
        return ['pdf', 'hwp', 'hwpx', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv', 'zip'].includes(ext);
    }

    public citationKind(citation: any): 'file' | 'link' {
        return this.citationIsDownloadable(citation) ? 'file' : 'link';
    }

    public downloadableCitations(message: ChatMessage): any[] {
        const citations = Array.isArray(message?.citations) ? message.citations : [];
        return this.uniqueCitations(citations.filter((citation) => this.citationIsDownloadable(citation)));
    }

    public linkCitations(message: ChatMessage): any[] {
        const citations = Array.isArray(message?.citations) ? message.citations : [];
        return this.uniqueCitations(citations.filter((citation) => !this.citationIsDownloadable(citation)));
    }

    private citationExtension(citation: any): string {
        const filePath = String(citation?.file_path || '').trim();
        if (filePath.includes('.')) {
            return filePath.split('.').pop()?.toLowerCase() || '';
        }
        const title = String(citation?.document_title || '').trim();
        if (title.includes('.')) {
            return title.split('.').pop()?.toLowerCase() || '';
        }
        const link = this.citationLink(citation);
        if (!link) return '';
        try {
            const pathname = new URL(link).pathname || '';
            if (!pathname.includes('.')) return '';
            return pathname.split('.').pop()?.toLowerCase() || '';
        } catch (e) {
            return '';
        }
    }

    public hasInlineCitationRefs(message: ChatMessage): boolean {
        const citations = Array.isArray(message?.citations) ? message.citations : [];
        const normalized = this.normalizedCitationContent(String(message?.content || ''), citations);
        return /\[(\d+)\]/.test(normalized);
    }

    private normalizedCitationContent(content: string, citations: any[]): string {
        const text = String(content || '');
        if (!text || !Array.isArray(citations) || citations.length === 0) return text;

        const fileIndices: number[] = [];
        const linkIndices: number[] = [];
        for (let index = 0; index < citations.length; index++) {
            if (this.citationIsDownloadable(citations[index])) fileIndices.push(index + 1);
            else linkIndices.push(index + 1);
        }
        if (fileIndices.length === 0) return text;

        const lines = text.split('\n');
        const attachmentLineIndex = lines.findIndex((line) => this.isAttachmentCitationLine(line));
        if (attachmentLineIndex === -1) return text;

        const fileMarkers = fileIndices.map((index) => `[${index}]`);
        for (let index = 0; index < lines.length; index++) {
            if (index === attachmentLineIndex) {
                let line = this.stripCitationMarkers(lines[index], linkIndices);
                const missingMarkers = fileMarkers.filter((marker) => !line.includes(marker));
                if (missingMarkers.length) {
                    line = `${line.replace(/[ \t]+$/g, '')} ${missingMarkers.join('')}`.trimEnd();
                }
                lines[index] = line;
                continue;
            }
            lines[index] = this.stripCitationMarkers(lines[index], fileIndices);
        }

        return lines.join('\n').replace(/[ \t]+\n/g, '\n');
    }

    private isAttachmentCitationLine(line: string): boolean {
        const text = String(line || '');
        return /(첨부파일|첨부|붙임|다운로드|파일)\s*:/i.test(text)
            || /\.(pdf|hwp|hwpx|doc|docx|xls|xlsx|ppt|pptx|csv|zip|png|jpe?g)\b/i.test(text);
    }

    private stripCitationMarkers(line: string, indices: number[]): string {
        let next = String(line || '');
        for (const index of indices || []) {
            next = next.replace(new RegExp(`\\s*\\[${index}\\]`, 'g'), '');
        }
        return next.replace(/[ \t]+$/g, '');
    }

    private linkifyCitationMarkers(html: string, citations: any[]): string {
        if (!html || !Array.isArray(citations) || citations.length === 0) return html;
        return html.replace(/\[(\d+)\]/g, (match, rawIndex) => {
            const displayIndex = Number(rawIndex);
            if (!Number.isFinite(displayIndex) || displayIndex < 1) return match;
            const citation = citations[displayIndex - 1];
            if (!citation) return match;
            const isDownloadable = this.citationIsDownloadable(citation);
            const href = this.escapeHtmlAttr(this.citationActionHref(citation, displayIndex - 1));
            const tooltip = this.escapeHtmlAttr(this.citationTooltip(citation, displayIndex - 1));
            const aria = this.escapeHtmlAttr(`${this.citationTitle(citation, displayIndex - 1)} ${isDownloadable ? '다운로드' : '새 창 열기'}`);
            const target = this.citationActionTarget(citation);
            const rel = this.citationActionRel(citation);
            const kind = this.escapeHtmlAttr(this.citationKind(citation));
            const targetAttr = target ? ` target="${this.escapeHtmlAttr(target)}"` : '';
            const relAttr = rel ? ` rel="${this.escapeHtmlAttr(rel)}"` : '';
            const tooltipAttr = tooltip ? ` data-tooltip="${tooltip}"` : '';
            const titleAttr = tooltip ? ` title="${tooltip}"` : '';
            const inlineStyle = isDownloadable
                ? 'display:inline-flex;align-items:center;justify-content:center;min-width:1.75em;padding:0 2px;margin:0 1px;border-radius:999px;background:transparent;color:#6d28d9;font-weight:800;text-decoration:none;box-shadow:none;cursor:pointer;'
                : 'display:inline-flex;align-items:center;justify-content:center;min-width:1.75em;padding:0 2px;margin:0 1px;border-radius:999px;background:transparent;color:#0f766e;font-weight:800;text-decoration:none;box-shadow:none;cursor:pointer;';
            return `<a class="citation-ref is-${kind}" href="${href}" aria-label="${aria}" data-kind="${kind}"${tooltipAttr}${titleAttr}${targetAttr}${relAttr} style="${inlineStyle}">${match}</a>`;
        });
    }

    private escapeHtmlAttr(value: string): string {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    private uniqueCitations(citations: any[]): any[] {
        const seen = new Set<string>();
        const items = [];
        for (const citation of citations || []) {
            const key = this.citationIdentity(citation);
            if (seen.has(key)) continue;
            seen.add(key);
            items.push(citation);
        }
        return items;
    }

    private citationIdentity(citation: any): string {
        return [
            String(citation?.document_id || '').trim(),
            String(citation?.file_path || '').trim(),
            String(citation?.source_url || '').trim(),
            String(citation?.document_title || '').trim(),
        ].join('::');
    }

    private linkifyPlainUrls(content: string): string {
        return content.replace(/(^|[\s>])((?:https?:\/\/|www\.)[^\s<]+)/gi, (match, prefix, rawUrl) => {
            let url = rawUrl || '';
            let trailing = '';
            while (/[),.!?]$/.test(url)) {
                trailing = url.slice(-1) + trailing;
                url = url.slice(0, -1);
            }
            if (!url) return match;
            const href = url.startsWith('http') ? url : `https://${url}`;
            return `${prefix}[${url}](${href})${trailing}`;
        });
    }

    private inferWeatherLabelFromContent(content: string): string | null {
        if (!content) return null;
        const statusLine = content.match(/상태:\s*\*{0,2}\s*([^\n*]+?)\s*\*{0,2}(?:\n|$)/);
        if (statusLine?.[1]) return statusLine[1].trim();

        const patterns = [
            /대체로 맑음/,
            /구름 조금/,
            /천둥번개/,
            /진눈깨비/,
            /이슬비/,
            /소나기/,
            /흐림/,
            /안개/,
            /맑음/,
            /비/,
            /눈/,
        ];
        for (const pattern of patterns) {
            const match = content.match(pattern);
            if (match?.[0]) return match[0];
        }
        return null;
    }

    // ---------- weather icon ----------
    public weatherIcon(m: ChatMessage): { cls: string; label: string } | null {
        const tc: any = (m.tool_calls || []).find((t: any) => t && t.tool === 'weather');
        if (tc) {
            const code = (tc.weather_code !== undefined && tc.weather_code !== null) ? Number(tc.weather_code) : null;
            const desc: string = tc.desc || '';
            return this.codeToIcon(code, desc);
        }

        if (m.intent !== 'weather') return null;
        const desc = this.inferWeatherLabelFromContent(m.content || '');
        if (!desc) return null;
        return this.codeToIcon(null, desc);
    }

    public weatherCaption(m: ChatMessage): string {
        const tc: any = (m.tool_calls || []).find((t: any) => t && t.tool === 'weather');
        const targetLabel = String(tc?.target_label || '').trim();
        const hours = (tc && tc.hours_offset !== undefined && tc.hours_offset !== null) ? Number(tc.hours_offset) : 0;
        if (Number.isFinite(hours) && hours > 0) {
            if (targetLabel) return `${targetLabel} 예보`;
            if (hours === 24) return '내일 예보';
            if (hours === 48) return '모레 예보';
            if (hours % 24 === 0) return `${Math.round(hours / 24)}일 뒤 예보`;
            return `${hours}시간 뒤 예보`;
        }
        const content = String(m?.content || '');
        if (/시간 뒤|내일|모레|예보/.test(content)) return '날씨 예보';
        return '현재 날씨';
    }

    private weatherTool(m: ChatMessage): any | null {
        return (m.tool_calls || []).find((t: any) => t && t.tool === 'weather') || null;
    }

    private finiteNumber(value: any): number | null {
        if (value === undefined || value === null || value === '') return null;
        const num = Number(value);
        return Number.isFinite(num) ? num : null;
    }

    public weatherHighlights(m: ChatMessage): Array<{ icon: string; label: string; value: string }> {
        const tc = this.weatherTool(m);
        if (!tc) return [];
        const items: Array<{ icon: string; label: string; value: string }> = [];
        const temp = this.finiteNumber(tc.temp_c);
        const hum = this.finiteNumber(tc.humidity);
        const pop = this.finiteNumber(tc.precipitation_probability);
        const maxPop = this.finiteNumber(tc.max_precipitation_probability);
        const dailyMin = this.finiteNumber(tc.daily_min_c);
        const dailyMax = this.finiteNumber(tc.daily_max_c);
        const rain = String(tc.precipitation || tc.forecast_precipitation || '').trim();
        const snow = String(tc.snow || tc.forecast_snow || '').trim();

        if (temp !== null) items.push({ icon: 'fa-temperature-half', label: '기온', value: `${temp}℃` });
        if (dailyMin !== null || dailyMax !== null) {
            const min = dailyMin !== null ? `${dailyMin}℃` : '-';
            const max = dailyMax !== null ? `${dailyMax}℃` : '-';
            items.push({ icon: 'fa-temperature-high', label: '범위', value: `${min}~${max}` });
        }
        if (hum !== null) items.push({ icon: 'fa-droplet', label: '습도', value: `${hum}%` });
        if (pop !== null) items.push({ icon: 'fa-umbrella', label: '강수', value: `${pop}%` });
        if (maxPop !== null && maxPop !== pop) items.push({ icon: 'fa-cloud-rain', label: '최대', value: `${maxPop}%` });
        if (rain && rain !== '강수없음') items.push({ icon: 'fa-cloud-showers-heavy', label: '강수량', value: rain });
        if (snow && snow !== '적설없음') items.push({ icon: 'fa-snowflake', label: '적설', value: snow });
        return items.slice(0, 6);
    }

    public weatherWindText(m: ChatMessage): string | null {
        const tc = this.weatherTool(m);
        if (!tc) return null;
        const speed = this.finiteNumber(tc.wind_kph);
        const direction = String(tc.wind_direction || '').trim();
        if (speed === null && !direction) return null;
        const parts: string[] = [];
        if (speed !== null) parts.push(`${speed} km/h`);
        if (direction) parts.push(direction);
        return parts.join(' · ');
    }

    public weatherWindTransform(m: ChatMessage): string {
        const tc = this.weatherTool(m);
        const degree = this.finiteNumber(tc?.wind_degree);
        if (degree !== null) return `rotate(${degree + 180}deg)`;
        const direction = String(tc?.wind_direction || '').trim();
        const fromDegree: any = { '북': 0, '북동': 45, '동': 90, '남동': 135, '남': 180, '남서': 225, '서': 270, '북서': 315 };
        if (fromDegree[direction] !== undefined) return `rotate(${fromDegree[direction] + 180}deg)`;
        return 'rotate(90deg)';
    }

    private codeToIcon(code: number | null, desc: string): { cls: string; label: string } {
        // WMO weather codes → FontAwesome 6 solid icons
        if (code === null || isNaN(code)) {
            if (/맑/.test(desc)) return { cls: 'fa-sun', label: desc || '맑음' };
            if (/흐림|구름/.test(desc)) return { cls: 'fa-cloud', label: desc || '흐림' };
            if (/비|소나기/.test(desc)) return { cls: 'fa-cloud-showers-heavy', label: desc || '비' };
            if (/눈/.test(desc)) return { cls: 'fa-snowflake', label: desc || '눈' };
            if (/안개/.test(desc)) return { cls: 'fa-smog', label: desc || '안개' };
            if (/천둥|번개/.test(desc)) return { cls: 'fa-cloud-bolt', label: desc || '천둥번개' };
            return { cls: 'fa-cloud-sun', label: desc || '날씨' };
        }
        if (code === 0) return { cls: 'fa-sun', label: desc || '맑음' };
        if (code === 1 || code === 2) return { cls: 'fa-cloud-sun', label: desc || '대체로 맑음' };
        if (code === 3) return { cls: 'fa-cloud', label: desc || '흐림' };
        if (code === 45 || code === 48) return { cls: 'fa-smog', label: desc || '안개' };
        if (code >= 51 && code <= 57) return { cls: 'fa-cloud-rain', label: desc || '이슬비' };
        if (code >= 61 && code <= 67) return { cls: 'fa-cloud-showers-heavy', label: desc || '비' };
        if (code >= 71 && code <= 77) return { cls: 'fa-snowflake', label: desc || '눈' };
        if (code >= 80 && code <= 82) return { cls: 'fa-cloud-showers-heavy', label: desc || '소나기' };
        if (code === 85 || code === 86) return { cls: 'fa-snowflake', label: desc || '진눈깨비' };
        if (code >= 95) return { cls: 'fa-cloud-bolt', label: desc || '천둥번개' };
        return { cls: 'fa-cloud-sun', label: desc || '날씨' };
    }

    public async loadFaq() {
        try {
            const r = await fetch('/api/ggeea/chat/faq', { credentials: 'include' });
            if (r.status === 200) {
                const body = await r.json();
                const data = body.data?.data || body.data;
                this.faqCategories = Array.isArray(data?.categories) ? data.categories : [];
                this.faqItems = (data?.items || []).filter((i: any) => i.active !== 0);
                this.buildFaqCards();
                this.rebuildFaqPages();
                this.tick();
                this.queueFaqMobileScrollSync(false);
            }
        } catch (e) { }
    }

    private async trackVisit() {
        try {
            await fetch('/api/ggeea/chat/visit', {
                method: 'POST',
                body: new FormData(),
                credentials: 'include',
            });
        } catch (e) { }
    }

    private buildFaqCards() {
        const cards: any[] = [];
        const grouped = new Map<string, any[]>();

        for (const item of this.faqItems) {
            const categoryId = String(item?.category_id || '__uncategorized__');
            const items = grouped.get(categoryId) || [];
            items.push(item);
            grouped.set(categoryId, items);
        }

        const pushCards = (title: string, items: any[], keyPrefix: string) => {
            for (let i = 0; i < items.length; i += this.faqItemsPerCard) {
                cards.push({
                    id: `${keyPrefix}-${Math.floor(i / this.faqItemsPerCard)}`,
                    title,
                    items: items.slice(i, i + this.faqItemsPerCard),
                });
            }
        };

        for (const category of this.faqCategories) {
            const categoryId = String(category?.id || '');
            const categoryItems = grouped.get(categoryId) || [];
            if (!categoryItems.length) continue;
            const title = String(category?.name || '').trim() || '자주 묻는 질문';
            pushCards(title, categoryItems, categoryId || 'faq');
            grouped.delete(categoryId);
        }

        const uncategorized = Array.from(grouped.values()).flat();
        if (uncategorized.length) {
            pushCards('기타 질문', uncategorized, 'uncategorized');
        }

        this.faqCards = cards;
    }

    public rebuildFaqPages() {
        const currentStart = Math.min(this.faqPageIndex * this.pageSize, Math.max(this.faqCards.length - 1, 0));
        this.pageSize = this.faqIsMobile ? 1 : 2;
        const pages: any[][] = [];
        for (let i = 0; i < this.faqCards.length; i += this.pageSize) {
            pages.push(this.faqCards.slice(i, i + this.pageSize));
        }
        this.faqPages = pages.length ? pages : [];
        this.faqPageIndex = this.faqPages.length ? Math.min(Math.floor(currentStart / this.pageSize), this.faqPages.length - 1) : 0;
    }

    public faqCurrentCards() {
        return this.faqPages[this.faqPageIndex] || [];
    }

    public faqCardDescription(card: any): string {
        const title = String(card?.title || '').trim();
        if (!title || title === '자주 묻는 질문') {
            return '자주 묻는 질문들을 확인해 보세요.';
        }
        return `${title} 카테고리의 질문입니다.`;
    }

    public goFaqPage(i: number) {
        if (i < 0 || i >= this.faqPages.length) return;

        if (this.faqIsMobile) {
            this.faqPageIndex = i;
            this.tick();
            this.scrollFaqMobileToIndex(i, true);
            return;
        }

        if (i === this.faqPageIndex) return;

        this.faqMotion = i > this.faqPageIndex ? 'next' : 'prev';
        this.faqPageIndex = i;
        this.faqAnimating = false;
        if (this.faqAnimationTimer) clearTimeout(this.faqAnimationTimer);
        this.tick();

        requestAnimationFrame(() => {
            this.faqAnimating = true;
            this.tick();
            this.faqAnimationTimer = setTimeout(() => {
                this.faqAnimating = false;
                this.tick();
            }, 420);
        });
    }
    public nextFaqPage() { this.goFaqPage(Math.min(this.faqPages.length - 1, this.faqPageIndex + 1)); }
    public prevFaqPage() { this.goFaqPage(Math.max(0, this.faqPageIndex - 1)); }

    public onFaqMobileScroll() {
        if (!this.faqIsMobile || this.faqScrollFrame !== null) return;
        this.faqScrollFrame = requestAnimationFrame(() => {
            this.faqScrollFrame = null;

            const track = this.faqMobileTrack?.nativeElement;
            if (!track) return;

            const slides = Array.from(track.children) as HTMLElement[];
            if (!slides.length) return;

            let nextIndex = this.faqPageIndex;
            let nearestDistance = Number.POSITIVE_INFINITY;
            const anchor = track.scrollLeft + 18;

            slides.forEach((slide, index) => {
                const distance = Math.abs(slide.offsetLeft - anchor);
                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nextIndex = index;
                }
            });

            if (nextIndex !== this.faqPageIndex) {
                this.faqPageIndex = nextIndex;
                this.tick();
            }
        });
    }

    private readonly onFaqViewportResize = () => {
        this.syncFaqViewport(false);
    };

    private syncFaqViewport(force: boolean) {
        const nextIsMobile = typeof window !== 'undefined' ? window.innerWidth <= this.faqMobileBreakpoint : false;
        if (!force && this.faqIsMobile === nextIsMobile) return;
        this.faqIsMobile = nextIsMobile;
        this.rebuildFaqPages();
        this.tick();
        this.queueFaqMobileScrollSync(false);
    }

    private queueFaqMobileScrollSync(smooth: boolean) {
        if (!this.faqIsMobile) return;
        if (this.faqScrollSyncTimer) clearTimeout(this.faqScrollSyncTimer);
        this.faqScrollSyncTimer = setTimeout(() => {
            this.scrollFaqMobileToIndex(this.faqPageIndex, smooth);
        }, 0);
    }

    private scrollFaqMobileToIndex(index: number, smooth: boolean) {
        const track = this.faqMobileTrack?.nativeElement;
        if (!track) return;

        const slide = track.children.item(index) as HTMLElement | null;
        if (!slide) return;

        try {
            track.scrollTo({
                left: slide.offsetLeft,
                behavior: smooth ? 'smooth' : 'auto',
            });
        } catch (e) {
            track.scrollLeft = slide.offsetLeft;
        }
    }

    private async streamLocalAnswer(target: ChatMessage, content: string) {
        this.pendingChars = Array.from(content || '');
        this.pendingTarget = target;
        this.startFlushLoop();
        await this.waitForBufferDrain();
        this.drainBuffer(target);
        this.stopFlushLoop();
        this.pendingTarget = null;
    }

    public async askFaq(item: any) {
        if (this.loading) return;

        const question = String(item?.question || '').trim();
        const answer = String(item?.answer || '').trim();
        if (!question || !answer) {
            this.service.alert('FAQ 답변을 찾을 수 없습니다.');
            return;
        }

        const userMsg = new ChatMessage();
        userMsg.role = 'user';
        userMsg.content = question;
        userMsg.intent = 'faq';
        userMsg.faq = item;

        this.loading = true;
        this.messages.push(userMsg);

        const asst = new ChatMessage();
        asst.role = 'assistant';
        asst.content = '';
        asst.streaming = true;
        asst.intent = 'faq';
        asst.faq = item;
        this.messages.push(asst);

        const faqLogPromise = this.service.logFaqTurn({
            sessionId: this.sessionId,
            question,
            answer,
            faqId: item?.id || null,
        }).catch(() => null);

        this.tick();
        this.scrollBottom();

        try {
            await this.streamLocalAnswer(asst, answer);
        } catch (e: any) {
            this.drainBuffer(asst);
            asst.error = true;
            asst.content = '죄송합니다. FAQ 답변을 불러오는 중 오류가 발생했습니다: ' + (e?.message || e);
        }

        const faqLog = await faqLogPromise;
        if (faqLog?.session_id) this.sessionId = faqLog.session_id;
        if (faqLog?.user_message_id) userMsg.messageId = faqLog.user_message_id;
        if (faqLog?.assistant_message_id) asst.messageId = faqLog.assistant_message_id;

        asst.streaming = false;
        this.loading = false;
        this.persist();
        this.tick();
        this.scrollBottom();
        this.focusInput();
    }

    public onKey(e: KeyboardEvent) {
        const composing = (e as any).isComposing || (e as any).keyCode === 229;
        if (e.key === 'Enter' && !e.shiftKey && !composing) {
            e.preventDefault();
            this.send();
        }
    }

    public persist() {
        if (this.sessionId) sessionStorage.setItem(this.sessionStorageKey, this.sessionId);
        try {
            const trimmed = this.messages.slice(-40);
            sessionStorage.setItem(this.messagesStorageKey, JSON.stringify(trimmed));
        } catch (e) { }
    }

    // ---------- smooth streaming ----------
    private startFlushLoop() {
        if (this.flushTimer) return;
        const step = () => {
            this.flushTimer = null;
            if (!this.pendingTarget) return;
            if (this.pendingChars.length === 0) return;

            const chunk = this.takeSmoothChunk();
            const lastChar = chunk.slice(-1);
            this.zone.run(() => {
                if (this.pendingTarget) this.pendingTarget.content += chunk;
                this.tick();
                this.scrollBottom();
            });

            if (this.pendingChars.length > 0) {
                this.flushTimer = setTimeout(step, this.nextStreamDelay(lastChar, this.pendingChars.length));
            }
        };
        this.flushTimer = setTimeout(step, 18);
    }

    private stopFlushLoop() {
        if (this.flushTimer) {
            clearTimeout(this.flushTimer);
            this.flushTimer = null;
        }
    }

    private takeSmoothChunk(): string {
        const backlog = this.pendingChars.length;
        let maxChunk = 1;
        if (backlog > 260) maxChunk = 8;
        else if (backlog > 180) maxChunk = 7;
        else if (backlog > 120) maxChunk = 6;
        else if (backlog > 70) maxChunk = 5;
        else if (backlog > 35) maxChunk = 4;
        else if (backlog > 15) maxChunk = 3;
        else if (backlog > 6) maxChunk = 2;

        let count = 0;
        while (count < maxChunk && count < this.pendingChars.length) {
            count += 1;
            const current = this.pendingChars[count - 1];
            if (current === '\n') break;
            if (/[.!?]/.test(current)) break;
            if (count >= 2 && /[,;:)]/.test(current)) break;
            if (count >= 2 && current === ' ' && backlog < 90) break;
        }

        return this.pendingChars.splice(0, count).join('');
    }

    private nextStreamDelay(lastChar: string, backlog: number): number {
        let delay = 18;
        if (backlog > 220) delay = 6;
        else if (backlog > 140) delay = 8;
        else if (backlog > 80) delay = 10;
        else if (backlog > 30) delay = 14;

        if (lastChar === '\n') return delay + 72;
        if (/[.!?]/.test(lastChar)) return delay + 58;
        if (/[,;:)]/.test(lastChar)) return delay + 34;
        if (lastChar === ' ') return Math.max(8, delay - 2);
        return delay;
    }

    private drainBuffer(target: ChatMessage) {
        // Immediately append any remaining buffered text
        if (this.pendingChars.length) {
            target.content += this.pendingChars.join('');
            this.pendingChars = [];
        }
    }

    public async send() {
        const ta = this.inputBox?.nativeElement;
        const liveValue = ta ? ta.value : this.input;
        const text = (liveValue || '').trim();
        if (!text || this.loading) return;

        this.input = '';
        if (ta) ta.value = '';
        this.loading = true;

        const userMsg = new ChatMessage();
        userMsg.role = 'user';
        userMsg.content = text;
        this.messages.push(userMsg);

        const asst = new ChatMessage();
        asst.role = 'assistant';
        asst.content = '';
        asst.streaming = true;
        this.messages.push(asst);

        // init buffer for smooth animation
        this.pendingChars = [];
        this.pendingTarget = asst;

        this.tick();
        this.scrollBottom();

        const history: { role: string; content: string }[] = [];
        const recent = this.messages.slice(-20, -2);
        for (const m of recent) {
            if (m.content && !m.error) history.push({ role: m.role, content: m.content });
        }

        try {
            await this.service.streamChat({
                query: text,
                sessionId: this.sessionId,
                history,
                onEvent: (ev) => {
                    this.zone.run(() => {
                        if (ev.type === 'session') {
                            if (ev.payload?.session_id) this.sessionId = ev.payload.session_id;
                        } else if (ev.type === 'meta') {
                            asst.intent = ev.payload?.intent;
                        } else if (ev.type === 'citations') {
                            asst.citations = ev.payload || [];
                        } else if (ev.type === 'delta') {
                            const chars = Array.from(String(ev.payload || ''));
                            if (chars.length) {
                                this.pendingChars.push(...chars);
                                this.startFlushLoop();
                            }
                        } else if (ev.type === 'error') {
                            this.drainBuffer(asst);
                            asst.error = true;
                            asst.content = (asst.content || '') + '\n\n⚠️ ' + ev.payload;
                            this.tick();
                        } else if (ev.type === 'done') {
                            asst.intent = ev.payload?.intent || asst.intent;
                            asst.tool_calls = ev.payload?.tool_calls || asst.tool_calls || [];
                            asst.citations = ev.payload?.citations || asst.citations || [];
                            // keep streaming flag true until buffer drained
                        } else if (ev.type === 'message_id') {
                            asst.messageId = ev.payload?.id || null;
                        }
                    });
                },
            });
        } catch (e: any) {
            this.zone.run(() => {
                this.drainBuffer(asst);
                asst.error = true;
                asst.content = '죄송합니다. 일시적인 오류가 발생했습니다: ' + (e?.message || e);
            });
        }

        // Wait for buffer to drain, then finalize
        await this.waitForBufferDrain();
        this.zone.run(() => {
            this.drainBuffer(asst);
            this.stopFlushLoop();
            this.pendingTarget = null;
            asst.streaming = false;
            this.loading = false;
            this.persist();
            this.tick();
            this.scrollBottom();
            this.focusInput();
        });
    }

    private waitForBufferDrain(): Promise<void> {
        return new Promise((resolve) => {
            const check = () => {
                if (this.pendingChars.length === 0 && !this.flushTimer) resolve();
                else setTimeout(check, 30);
            };
            check();
        });
    }

    public async feedback(msg: ChatMessage, value: number) {
        if (!msg.messageId) return;
        msg.feedback = value;
        this.tick();
        try { await this.service.feedback(msg.messageId, value); } catch (e) { }
    }

    public toggleMenu() { this.menuOpen = !this.menuOpen; this.tick(); }
    public closeMenu() {
        if (this.menuOpen) { this.menuOpen = false; this.tick(); }
    }

    public clearChat() {
        this.menuOpen = false;
        if (!this.service.confirm('대화 내용을 초기화할까요?')) return;
        this.messages = [];
        this.sessionId = null;
        sessionStorage.removeItem(this.messagesStorageKey);
        sessionStorage.removeItem(this.sessionStorageKey);
        this.tick();
    }

    public trackMsg(i: number, m: ChatMessage) { return m; }
    public trackPage(i: number) { return i; }

    private scrollBottom() {
        if (this.scrollBottomTimer) clearTimeout(this.scrollBottomTimer);
        this.scrollBottomTimer = setTimeout(() => {
            this.scrollBottomTimer = null;
            const el = this.scrollArea?.nativeElement;
            if (!el) return;
            this.scrollBottomTarget = Math.max(el.scrollHeight - el.clientHeight, 0);
            if (this.scrollBottomFrame !== null) return;

            const step = () => {
                const node = this.scrollArea?.nativeElement;
                if (!node) {
                    this.scrollBottomFrame = null;
                    return;
                }

                const target = Math.max(this.scrollBottomTarget, 0);
                const distance = target - node.scrollTop;
                if (Math.abs(distance) < 2) {
                    node.scrollTop = target;
                    this.scrollBottomFrame = null;
                    return;
                }

                node.scrollTop += distance * 0.22;
                this.scrollBottomFrame = requestAnimationFrame(step);
            };

            this.scrollBottomFrame = requestAnimationFrame(step);
        }, 10);
    }

    private focusInput() {
        try { this.inputBox?.nativeElement.focus(); } catch (e) { }
    }
}

export default PageMainComponent;